import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth/AuthContext'
import { apiClient, ApiClientError } from '../../services/apiClient'

/**
 * Cambio de contraseña forzado para usuarios invitados al equipo.
 * Se muestra automáticamente cuando must_change_password === true.
 * No tiene navegación de retorno — el usuario debe cambiar la contraseña para continuar.
 */
export function ForceChangePasswordPage() {
  const { refreshUser } = useAuth()
  const navigate = useNavigate()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas nuevas no coinciden.')
      return
    }
    if (newPassword.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres.')
      return
    }

    setSaving(true)
    try {
      await apiClient.post('/me/change-password', {
        current_password: currentPassword,
        new_password: newPassword,
      })
      await refreshUser()
      navigate('/dashboard', { replace: true })
    } catch (err) {
      setError(err instanceof ApiClientError ? err.apiError.message : 'No se pudo cambiar la contraseña.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-card__title">Cambiar contraseña</h1>
        <p className="muted">Por seguridad, debes cambiar la contraseña temporal antes de continuar.</p>

        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="field">
            <span>Contraseña temporal</span>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              autoComplete="current-password"
              disabled={saving}
            />
          </label>

          <label className="field">
            <span>Nueva contraseña <em className="muted">(mín. 8 caracteres)</em></span>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              minLength={8}
              required
              autoComplete="new-password"
              disabled={saving}
            />
          </label>

          <label className="field">
            <span>Confirmar nueva contraseña</span>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              minLength={8}
              required
              autoComplete="new-password"
              disabled={saving}
            />
          </label>

          {error && <p className="error">{error}</p>}

          <button type="submit" className="primary-btn primary-btn--full" disabled={saving}>
            {saving ? 'Cambiando…' : 'Cambiar contraseña y continuar'}
          </button>
        </form>
      </div>
    </div>
  )
}
